import { get } from 'lodash';
import { createSelector } from 'reselect';

const allDomainsIdsSelector = state => get( state, 'domains.allIds', [] );
export const domainsByIdSelector = state => get( state, 'domains.byId', {} );
export const domainsIsLoadingSelector = state => get( state, 'domains.isLoading', false );

export const domainsSelector = createSelector(
    allDomainsIdsSelector,
    domainsByIdSelector,
    ( domainIds, domainMap ) => domainIds.map( id => domainMap[id] ) );

export const domainNamesSelector = createSelector(
    domainsSelector,
    ( domains ) => domains.map( domain => domain.domainName )
);

export const domainsPolicyCountsSelector = createSelector(
    domainsByIdSelector,
    ( domainIds ) => {
        const counts = {
            no_record: 0,
            none: 0,
            quarantine: 0,
            reject: 0,
        };

        for( let domain in domainIds ){
            const policy = get( domainIds[domain], 'dmarc.policy', 'no_record' ) || 'no_record';
            counts[policy]++;
        }

        return counts;
    }
);
